import { render } from "./FileLabelsModal.vue?vue&type=template&id=29fa33b2"
import script from "./FileLabelsModal.vue?vue&type=script&lang=js"
export * from "./FileLabelsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__